import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to extract the last category from a category path
 * 
 * @example
 * ```html
 * {{ "Đồ sơ sinh/Quần áo sơ sinh - basic/Áo sơ sinh dài tay Xuân - Hè" | lastCategory }}
 * <!-- Output: "Áo sơ sinh dài tay Xuân - Hè" -->
 * 
 * {{ "Drinks" | lastCategory }}
 * <!-- Output: "Drinks" -->
 * ```
 */
@Pipe({
  name: 'lastCategory',
  standalone: true
})
export class LastCategoryPipe implements PipeTransform {

  /**
   * Transforms a category path to show only the last category
   * @param categoryPath - The full category path (e.g., "Đồ sơ sinh/Quần áo sơ sinh - basic/Áo sơ sinh dài tay Xuân - Hè")
   * @returns The last category name
   */
  transform(categoryPath: string): string {
    if (!categoryPath) return '';
    const parts = categoryPath.split('/');
    return parts[parts.length - 1] || categoryPath;
  }
}
